'use client';

import { motion } from 'motion/react';

interface LogoSpinnerProps {
  className?: string;
  size?: number;
}

export default function LogoSpinner({ className = '', size = 64 }: LogoSpinnerProps) {
  return (
    <motion.svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 124.574 123.6"
      width={size}
      height={size}
      className={className}
      initial={{ scale: 0.9 }}
      animate={{
        scale: [0.9, 1.1, 0.9],
      }}
      transition={{
        duration: 1.5,
        repeat: Infinity,
        ease: 'easeInOut',
      }}
    >
      <g transform="translate(-151.385,-56.176)">
        {/* Inner frame */}
        <path
          className="fill-[#283578] dark:fill-white"
          d="m 179.01543,84.035181 v 68.298669 h 68.33226 V 102.1457 l -5.80068,-5.419821 V 146.53524 H 184.81456 V 89.833793 h 49.35616 l -6.20634,-5.798612 z m 59.50128,0 8.83098,8.154024 v -8.154024 z"
        />
        {/* Outer frame */}
        <path
          className="fill-[#283578] dark:fill-white"
          d="m 173.79869,56.175899 c -12.23776,0 -22.41413,10.177927 -22.41413,22.415686 v 78.767805 c 0,12.23776 10.17637,22.4162 22.41413,22.4162 h 79.74449 c 12.23776,0 22.41569,-10.17844 22.41569,-22.4162 v -27.75593 c -6.94335,-6.48763 -13.88638,-12.97528 -20.82974,-19.4629 v 47.21883 c 0,1.05825 -0.52771,1.58595 -1.58595,1.58595 h -79.74449 c -1.05824,0 -1.58388,-0.5277 -1.58388,-1.58595 V 78.591585 c 0,-1.058241 0.52564,-1.585949 1.58388,-1.585949 h 45.86801 c -7.4312,-6.94337 -14.86252,-13.886388 -22.29373,-20.829737 z m 35.3255,0 c 7.52003,6.943282 15.03994,13.886331 22.55986,20.829737 h 21.85913 c 1.05824,0 1.58595,0.527708 1.58595,1.585949 V 98.65341 c 6.94327,6.41084 13.88627,12.82179 20.82974,19.23242 V 78.591585 c 0,-12.237759 -10.17793,-22.415686 -22.41569,-22.415686 z"
        />
        {/* Orange triangle */}
        <path
          fill="#f9870e"
          d="m 208.34387,56.175899 67.57986,62.398261 0.0336,9.87743 0.002,0.002 V 56.175899 Z"
        />
      </g>
    </motion.svg>
  );
}
